// App constants

export const APP_NAME = 'XPunters';
export const APP_VERSION = '1.0.0';
export const CURRENCY_SYMBOL = '$XPUNT';

// Update referral constants
export const REFERRAL_ADMIN_FEE_PERCENTAGE = 20; // 20% of admin fees
export const ADMIN_FEE_PERCENTAGE = 10; // 15% admin fee on all transactions
 
 

export const CURRENCIES = {
  NGN: { symbol: '₦', name: 'Nigerian Naira', rate: 1500 },
  GHS: { symbol: '₵', name: 'Ghanaian Cedi', rate: 12 },
  KES: { symbol: 'KSh', name: 'Kenyan Shilling', rate: 130 },
  ZAR: { symbol: 'R', name: 'South African Rand', rate: 18 },
  USD: { symbol: '$', name: 'US Dollar', rate: 1 },
  EUR: { symbol: '€', name: 'Euro', rate: 0.92 },
  GBP: { symbol: '£', name: 'British Pound', rate: 0.79 },
};

// Punter+ Subscription Plans (in $XPUNT) 
export const PUNTER_PLUS_PLANS = {
  MONTHLY: {
    id: 'monthly',
    label: 'Monthly',
    price: 2,
    duration: '1 month',
    durationDays: 30,
    savings: 0,
    popular: false,
    features: [
      'Create private bet codes',
      'Create competitions',
      'Create H2H games',
      'Access to premium features',
      'Priority support',
    ],
  },
  BI_ANNUAL: {
    id: 'bi-annual',
    label: 'Bi-Annual',
    price: 10,
    duration: '6 months',
    durationDays: 180,
    savings: 20,
    popular: true,
    features: [
      'All Monthly features',
      'Save 20% compared to monthly',
      'Create rollover games',
      'Advanced analytics',
      'Early access to new features',
    ],
  },
  YEARLY: {
    id: 'yearly',
    label: 'Yearly',
    price: 18,
    duration: '1 year',
    durationDays: 365,
    savings: 33,
    popular: false,
    features: [
      'All Bi-Annual features',
      'Save 33% compared to monthly',
      'Unlimited bet codes',
      'Priority in competitions',
      'Exclusive bonuses',
      'Premium badge',
    ],
  },
};

// Creator Subscription Types
export const CREATOR_SUBSCRIPTION_TYPES = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
};

export const CREATOR_SUBSCRIPTION_PRICES = {
  [CREATOR_SUBSCRIPTION_TYPES.WEEKLY]: 1,
  [CREATOR_SUBSCRIPTION_TYPES.MONTHLY]: 3,
};

export const BET_STATUSES = {
  RUNNING: 'running',
  WON: 'won',
  LOST: 'loose',
  PENDING: 'pending',
  PRIVATE: 'private',
  COMPLETED: 'completed',
  REFUNDED: 'refunded',
  CANCELLED: 'cancelled',
};

export const BET_STATUS_COLORS = {
  [BET_STATUSES.RUNNING]: '#3498db',
  [BET_STATUSES.WON]: '#2ecc71',
  [BET_STATUSES.LOST]: '#e74c3c',
  [BET_STATUSES.PENDING]: '#f39c12',
  [BET_STATUSES.PRIVATE]: '#9b59b6',
  [BET_STATUSES.COMPLETED]: '#95a5a6',
  [BET_STATUSES.REFUNDED]: '#e67e22',
  [BET_STATUSES.CANCELLED]: '#c0392b',
};

export const SUBSCRIPTION_TYPES = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
};

export const SUBSCRIPTION_PRICES = {
  [SUBSCRIPTION_TYPES.WEEKLY]: 1,
  [SUBSCRIPTION_TYPES.MONTHLY]: 3,
  [SUBSCRIPTION_TYPES.YEARLY]: 30,
};

export const REFERRAL_BONUS = 5;
export const WELCOME_BONUS = 3;
export const MIN_WITHDRAWAL = 10;

export const PLATFORMS = [
  'SportyBet',
  'Bet9ja',
  '1xBet',
  'Betway',
  'Bet365',
  'NairaBet',
  'MerryBet',
  'Other',
];

export const MARKETS = [
  'Multiple',
  'Single',
  'Accumulator',
  'System',
];

export const CONFIDENCE_LEVELS = [
  { value: 'high', label: '🔥 High', color: '#2ecc71' },
  { value: 'medium', label: '👍 Medium', color: '#f39c12' },
  { value: 'low', label: '👎 Low', color: '#e74c3c' },
];

export const GAME_TYPES = [
  'football',
  'basketball',
  'tennis',
  'baseball',
  'hockey',
  'other',
];

export const H2H_OUTCOMES = [
  'Home Win',
  'Draw',
  'Away Win',
];

export const PREDICTION_OUTCOMES = [
  { name: 'Home Win', points: 10 },
  { name: 'Draw', points: 15 },
  { name: 'Away Win', points: 10 },
  { name: 'Correct Score', points: 25 },
  { name: 'Over 2.5', points: 8 },
  { name: 'Under 2.5', points: 8 },
  { name: 'GG (Both Score)', points: 12 },
  { name: 'NG (No Goal)', points: 12 },
];

export const EMAIL_PREFERENCE_TYPES = [
  { key: 'bet_marked', label: 'Bet Marked', icon: '📌' },
  { key: 'bet_code_created', label: 'Bet Code Created', icon: '📢' },
  { key: 'prediction_result', label: 'Prediction Result', icon: '🎯' },
  { key: 'h2h_result', label: 'H2H Result', icon: '🏆' },
  { key: 'competition_update', label: 'Competition Update', icon: '📊' },
  { key: 'subscription_update', label: 'Subscription Update', icon: '📰' },
  { key: 'wallet_update', label: 'Wallet Update', icon: '💰' },
  { key: 'rollover_update', label: 'Rollover Update', icon: '🔄' },
  { key: 'referral_bonus', label: 'Referral Bonus', icon: '🎁' },
  { key: 'creator_subscription', label: 'Creator Subscription', icon: '⭐' },
  { key: 'private_bet_notification', label: 'Private Bet', icon: '🔒' },
  { key: 'winner_notification', label: 'Winner', icon: '👑' },
];

export default {
  APP_NAME,
  APP_VERSION,
  CURRENCY_SYMBOL,
  CURRENCIES,
  PUNTER_PLUS_PLANS,
  CREATOR_SUBSCRIPTION_TYPES,
  CREATOR_SUBSCRIPTION_PRICES,
  BET_STATUSES,
  BET_STATUS_COLORS,
  SUBSCRIPTION_TYPES,
  SUBSCRIPTION_PRICES,
  REFERRAL_BONUS,
  WELCOME_BONUS,
  MIN_WITHDRAWAL,
  PLATFORMS,
  MARKETS,
  CONFIDENCE_LEVELS,
  GAME_TYPES,
  H2H_OUTCOMES,
  PREDICTION_OUTCOMES,
  EMAIL_PREFERENCE_TYPES,
};